module.exports = __webpack_public_path__ + "static/vmware_24.471832df.jpg";